import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { APP_PROPS } from '../../../../cai-common.module';
import { ApplicationProperties } from '../../../../core/_base/layout/models/app-properties.model';

@Component({
  selector: 'cai-settings-layout',
  templateUrl: './settings-layout.component.html',
  styleUrls: ['settings-layout.component.scss'],
  standalone: false,
})
export class SettingsLayoutComponent {
  @Input()
  tabTitle: string;
  @Input()
  items: NavGroup[];
  @Input()
  selectedNavItem: string;
  @Input()
  selectedNavSubItem: string;
  @Output()
  onSelectNavItem = new EventEmitter<string>();
  @Output()
  onSelectNavSubItem = new EventEmitter<string>();

  constructor(
    @Inject(APP_PROPS)
    readonly appProperties: ApplicationProperties,
  ) {}
}

export interface NavGroup {
  groupName: string;
  groupItems: NavItem[];
}

export interface NavItem {
  key: string;
  label: string;
  iconUrl?: string;
  subItems?: NavItem[];
}
